import { MdScatterPlot } from "react-icons/md";

const getDataFieldsScatter = () => {
  return [
    {
      title: "X/Y Axes",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Points",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Category",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      reduxKey: "rows",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: Number,
      canEdit: true,
    },
  ];
};

const getCustomizationFieldScatter = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Point Size",
      type: "range",
      defaultValue: 4,
      minValue: 1,
      maxValue: 20,
      reduxKey: "pointSize",
      itemInArray: false,
    },
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isLabelVisible",
      innerComponents: [
        {
          title: "Position",
          type: "SELECT_BOX",
          reduxKey: "labelPosition",
          options: [
            { label: "Top", value: "top" },
            { label: "Bottom", value: "bottom" },
            { label: "Center", value: "center" },
          ],
          defaultValue: { label: "Top", value: "top" },
          isParent: true,
        },
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },

        {
          title: "Font Size",
          type: "range",
          defaultValue: 11,
          minValue: 10,
          maxValue: 40,
          reduxKey: "labelFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Rotate",
          type: "range",
          defaultValue: 0,
          minValue: 0,
          maxValue: 360,
          reduxKey: "labelRotate",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },

    //shap
    {
      title: "Shapes",
      type: "SELECT_BOX",
      reduxKey: "labelShapes",
      options: [
        { label: "Dot", value: "dot" },
        { label: "Star", value: "star" },

        { label: "Triangle", value: "triangle" },
        { label: "Cross", value: "cross" },

        // { label: "Cross", value: "cross" },
        // { label: "Cross", value: "cross" },
      ],
      defaultValue: { label: "Dot", value: "dot" },
      isParent: true,
    },
    //grid
    {
      title: "Grid",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isGridVisible",
    },

    //X/Y
    // {
    //   title: "Axes label",
    //   type: "checkbox",
    //   defaultValue: false,
    //   reduxKey: "isXYVisible",
    // },

    // axes label
    {
      title: "Axes label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isAxeslabelVisible",
      innerComponents: [
        {
          title: "Font Size",
          type: "range",
          defaultValue: 21,
          minValue: 20,
          maxValue: 40,
          reduxKey: "labelAxesFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelAxesFontColor",
          defaultValue: "#878787",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },
    //legend
    {
      title: "Legend",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isLegendVisible",
      innerComponents: [
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "legendFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isLegendBold",
          isParent: true,
        },
        {
          title: "Align",
          type: "SELECT_BOX",
          reduxKey: "legendAlign",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
          defaultValue: { label: "Center", value: "center" },
          isParent: true,
        },
        {
          title: "Vertical Align",
          type: "SELECT_BOX",
          reduxKey: "legendVerticalAlign",
          options: [
            { label: "Top", value: "top" },

            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Bottom", value: "top" },
          isParent: true,
        },
        {
          title: "Layout",
          type: "SELECT_BOX",
          reduxKey: "legendLayout",
          options: [
            { label: "Horizontal", value: "horizontal" },
            { label: "Vertical", value: "vertical" },
          ],
          defaultValue: { label: "Horizontal", value: "horizontal" },
          isParent: true,
        },
      ],
    },
    //textbox
    {
      title: "Title",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isTileVisible",
      innerComponents: [
        {
          title: "Title",
          type: "text",
          defaultValue: "title...",
          minValue: 0,
          maxValue: 20,
          reduxKey: "Title",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isTitleBold",
          isParent: true,
        },
        {
          title: "Title Color",
          type: "fontColor",
          reduxKey: "TitleFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Title Size",
          type: "range",
          defaultValue: 25,
          minValue: 8,
          maxValue: 30,
          reduxKey: "TitleSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },

        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },



      ],
    },
  ];
};
const getScatterChartDetails = () => {
  return {
    chartType: "recharts",
    imageSrc: "/graph_img/Bubblechart.png",
    label: "Scatter",
    value: "scatterchart",
    icon: <MdScatterPlot className="text-xl text-blue-950" />,
    fileName: "ScatterChartComp.js",
  };
};
export {
  getDataFieldsScatter,
  getCustomizationFieldScatter,
  getScatterChartDetails,
};
